var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStVincentAndTheGrenadines(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 512,
    viewBox: "0 0 513 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.013 31.128C342.642 11.284 300.928 0.000976562 256.578 0.000976562C212.228 0.000976562 170.514 11.284 134.143 31.128L111.882 256.001L134.143 480.874C170.514 500.718 212.228 512.001 256.578 512.001C300.928 512.001 342.642 500.718 379.013 480.874L401.274 256.001L379.013 31.128Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.143 480.872V31.127C54.5671 74.547 0.578125 158.966 0.578125 256.001C0.578125 353.036 54.5671 437.455 134.143 480.872Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.578 256.001C512.578 158.966 458.589 74.547 379.013 31.127V480.872C458.589 437.455 512.578 353.036 512.578 256.001V256.001Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.926 322.784L156.403 256.001L200.925 189.218L245.449 256.001L200.926 322.784Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.23 322.784L267.708 256.001L312.23 189.218L356.752 256.001L312.23 322.784Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.578 411.827L212.056 345.044L256.578 278.262L301.1 345.044L256.578 411.827Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0.578125 0.000976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStVincentAndTheGrenadines);
export default __webpack_public_path__ + "static/media/stVincentAndTheGrenadines.38805f709c80a03f7e5daed3cb81f250.svg";
export { ForwardRef as ReactComponent };